import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export const getPocToken = async (accessAuthToken, signal?: AbortSignal): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/rotogpt/auth/auth_token`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      signal: signal,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Request failed");
    }

    const responseData = await response.json();
    // console.log("signin token", responseData);

    return responseData;
  } catch (error) {
    showErrorToast("Something went wrong when signing in");
    throw error;
  }
};
